/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

export default {
  ADD_EVENT(state, event) {
    Vue.set(event, 'startDate', event.start_time)
    Vue.set(event, 'endDate', event.end_time)
    Vue.set(event, 'classes',  'event-'+ event.color)
    state.events.push(event)
  },
  SET_EVENTS(state, events) {
    state.events = events
    for (var index in state.events){
      // TODO: 로직 변경 필요. loop
      Vue.set(state.events[index], 'startDate', state.events[index].start_time)
      Vue.set(state.events[index], 'endDate', state.events[index].end_time)
      Vue.set(state.events[index], 'classes',  'event-'+state.events[index].color)      
    }
  },
  SET_LABELS(state, labels) {
    state.eventLabels = labels
  },
  UPDATE_EVENT(state, event) {
    Vue.set(event, 'startDate', event.start_time)
    Vue.set(event, 'endDate', event.end_time)
    Vue.set(event, 'classes',  'event-'+ event.color)
    const eventIndex = state.events.findIndex((e) => e.id == event.id)
    Object.assign(state.events[eventIndex], event)
  },
  REMOVE_EVENT(state, eventId) {
    const eventIndex = state.events.findIndex((e) => e.id == eventId)
    state.events.splice(eventIndex, 1)
  },
}
